(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const menu = document.querySelector('[data-ura-menu]');
  const opener = document.querySelector('[data-ura-menu-open]');
  const menuBackdrop = document.querySelector('[data-ura-menu-dismiss]');
  const header = document.querySelector('.ura-header');
  const viewport = menu?.querySelector('.ura-index__viewport');
  const heritageToggle = menu?.querySelector('[data-ura-heritage-toggle]');
  const heritageDisclosure = menu?.querySelector('[data-ura-heritage-disclosure]');
  let menuCloseTimer;
  let menuLeaveTimer;
  let suppressFocusOpen=false;
  let openedByHover=false;
  let positionFrame;
  const fineMenuHover=matchMedia('(hover:hover) and (pointer:fine)');
  const MENU_LEAVE_DELAY=400;
  const accountOpen = () => document.documentElement.classList.contains('ura-account-sheet-open') || Boolean(document.querySelector('shopify-account[data-ura-account-open="true"]'));
  const setHeritageOpen = (open) => {
    heritageToggle?.setAttribute('aria-expanded',String(open));
    if(heritageDisclosure){
      heritageDisclosure.setAttribute('aria-hidden',String(!open));
      heritageDisclosure.inert = !open;
    }
    menu?.classList.toggle('is-heritage-open',open);
  };
  const setGeometry = (node, key, value) => {
    if(node.style.getPropertyValue(key)!==value)node.style.setProperty(key,value);
  };
  const positionMenu = () => {
    positionFrame=0;
    if(!header || document.hidden) return;
    const rect = header.getBoundingClientRect();
    const visibleViewport = window.visualViewport;
    const height = visibleViewport?.height || window.innerHeight;
    const offset = visibleViewport?.offsetTop || 0;
    const preview = document.getElementById('PBarNextFrameWrapper');
    const previewTop = preview && getComputedStyle(preview).position === 'fixed' ? preview.getBoundingClientRect().top : height + offset;
    const bottom = Math.min(height + offset, previewTop);
    const gutter = window.innerWidth <= 760 ? 12 : 24;
    const surfaceBottom = Math.max(offset, rect.bottom);
    const top = Math.max(offset + 8,Math.min(surfaceBottom + 8,bottom - 180));
    const panelHeight = Math.max(120,bottom - top - 12);
    const root = document.documentElement;
    const inset = Math.max(gutter,root.getBoundingClientRect().right - rect.right);
    const menuOpen = menu && !menu.hidden;
    const desktopMenu = window.innerWidth > 760;
    const width = Math.min(desktopMenu?1200:560,window.innerWidth-gutter*2);
    const origin = menuOpen ? opener?.getBoundingClientRect() : null;
    const left = desktopMenu ? Math.max(gutter,(window.innerWidth-width)/2)
      : Math.max(gutter,Math.min(origin?.left ?? rect.left,window.innerWidth-width-gutter));
    setGeometry(root,'--ura-viewport-height',Math.max(320,bottom-offset)+'px');
    setGeometry(root,'--ura-header-surface-bottom',surfaceBottom+'px');
    setGeometry(root,'--ura-header-panel-top',top+'px');
    setGeometry(root,'--ura-header-panel-height',panelHeight+'px');
    setGeometry(root,'--ura-header-panel-inset',inset+'px');
    if(!menuOpen)return;
    setGeometry(menu,'--ura-panel-top',top+'px');
    setGeometry(menu,'--ura-panel-left',left+'px');
    if(origin){
      setGeometry(menu,'--ura-panel-origin-x',(origin.left+origin.width/2-left)+'px');
      setGeometry(menu,'--ura-panel-origin-y',(origin.top+origin.height/2-top)+'px');
    }
    setGeometry(menu,'--ura-panel-height',panelHeight+'px');
    setGeometry(menu,'--ura-panel-width',width+'px');
  };
  const closeMenu = (restoreFocus=false,immediate=false) => {
    openedByHover=false;
    if(!menu || menu.hidden) return;
    clearTimeout(menuCloseTimer);
    clearTimeout(menuLeaveTimer);

    menu.inert = true;
    if(menuBackdrop) menuBackdrop.hidden=true;
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    opener?.setAttribute('aria-expanded','false');
    opener?.setAttribute('aria-label',opener.dataset.openLabel || 'Open menu');
    document.body.classList.remove('ura-menu-panel-open');
    const finish = () => { menu.hidden=true;menu.classList.remove('is-closing');setHeritageOpen(false); };
    if(immediate || reducedMotion.matches) finish();
    else menuCloseTimer=setTimeout(finish,170);
    if(restoreFocus && opener){
      suppressFocusOpen=true;
      opener.focus({preventScroll:true});
      requestAnimationFrame(()=>{suppressFocusOpen=false;});
    }
  };
  const openMenu = () => {
    if(!menu || !opener) return;
    clearTimeout(menuCloseTimer);
    clearTimeout(menuLeaveTimer);
    if(menu.classList.contains('is-open')) return;
    menu.hidden=false;
    if(menuBackdrop) menuBackdrop.hidden=false;
    menu.inert=false;
    menu.classList.remove('is-closing');
    setHeritageOpen(false);
    menu.querySelectorAll('.ura-shop-group[open]').forEach(group=>{group.open=false;});
    if(viewport) viewport.scrollTop=0;
    positionMenu();
    document.body.classList.add('ura-menu-panel-open');
    opener.setAttribute('aria-expanded','true');
    opener.setAttribute('aria-label',opener.dataset.closeLabel || 'Close menu');
    menu.classList.add('is-open');

  };
  const scheduleMenuLeaveClose=(relatedTarget)=>{
    if(!fineMenuHover.matches||!openedByHover||accountOpen()||menu?.contains(document.activeElement)) return;
    if(relatedTarget instanceof Node&&(opener?.contains(relatedTarget)||menu?.contains(relatedTarget))) return;
    clearTimeout(menuLeaveTimer);
    menuLeaveTimer=setTimeout(()=>{if(openedByHover&&!accountOpen()&&!menu?.contains(document.activeElement))closeMenu(false);},MENU_LEAVE_DELAY);
  };
  menuBackdrop?.addEventListener('click',()=>closeMenu(true));
  opener?.addEventListener('click',(event)=>{
    const open=opener.getAttribute('aria-expanded')==='true';
    if(open && openedByHover){openedByHover=false;return;}
    open?closeMenu(true):openMenu();
  });
  opener?.addEventListener('pointerenter',()=>{
    if(!fineMenuHover.matches) return;
    clearTimeout(menuLeaveTimer);
    if(opener.getAttribute('aria-expanded')!=='true') openedByHover=true;
    openMenu();
  });
  menu?.addEventListener('pointerenter',()=>{
    if(fineMenuHover.matches) clearTimeout(menuLeaveTimer);
  });
  opener?.addEventListener('pointerleave',event=>scheduleMenuLeaveClose(event.relatedTarget));
  menu?.addEventListener('pointerleave',event=>scheduleMenuLeaveClose(event.relatedTarget));
  fineMenuHover.addEventListener('change',()=>clearTimeout(menuLeaveTimer));
  /* URA shop-group single-open guard */
  menu?.querySelectorAll('.ura-shop-group').forEach(group=>{
    group.addEventListener('toggle',()=>{
      if(!group.open)return;
      menu.querySelectorAll('.ura-shop-group').forEach(other=>{if(other!==group)other.open=false;});
    });
  });
  heritageToggle?.addEventListener('click',()=>setHeritageOpen(heritageToggle.getAttribute('aria-expanded')!=='true'));
  document.addEventListener('pointerdown',(event)=>{
    if(menu?.hidden || menu?.contains(event.target) || opener?.contains(event.target) || accountOpen()) return;
    closeMenu(false,true);
  },true);
  document.addEventListener('focusin',(event)=>{
    if(opener?.contains(event.target)){
      return;
    }
    if(menu?.hidden||menu?.contains(event.target)||accountOpen()) return;
    closeMenu(false,true);
  });
  document.addEventListener('keydown',(event)=>{
    if(!menu || menu.hidden) return;
    if(event.key==='Escape'){
      if(accountOpen()) return;
      event.preventDefault();
      if(heritageToggle?.getAttribute('aria-expanded')==='true'){setHeritageOpen(false);heritageToggle.focus();}
      else closeMenu(true);
    }else if(event.key==='Tab' && document.activeElement===opener && !event.shiftKey){
      event.preventDefault();
      (menu.querySelector('[data-ups-toggle]:not([hidden])') || menu.querySelector('input[type="search"]') || menu.querySelector('.ura-shop-card[href]'))?.focus();
    }
  });
  const queuePosition = () => {
    if(!positionFrame&&!document.hidden)positionFrame=requestAnimationFrame(positionMenu);
  };
  window.addEventListener('resize',queuePosition);
  window.addEventListener('scroll',queuePosition,{passive:true});
  window.visualViewport?.addEventListener('resize',queuePosition);
  window.visualViewport?.addEventListener('scroll',queuePosition);
  const headerHost = header?.parentElement;
  const signal = headerHost?.querySelector('.ura-signal');
  const syncHeaderGeometry = () => {
    if(headerHost)setGeometry(headerHost,'--ura-signal-height',`${signal?.getBoundingClientRect().height || 0}px`);
    queuePosition();
  };
  syncHeaderGeometry();
  window.addEventListener('load',queuePosition,{once:true});
  const previewObserver=new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node instanceof Element&&(node.id==='PBarNextFrameWrapper'||node.querySelector?.('#PBarNextFrameWrapper'))))){queuePosition();previewObserver.disconnect();}});
  if(!document.getElementById('PBarNextFrameWrapper'))previewObserver.observe(document.body,{childList:true,subtree:true});
  if (headerHost && 'ResizeObserver' in window) {
    const headerObserver = new ResizeObserver(syncHeaderGeometry);
    headerObserver.observe(headerHost);
  }
  document.addEventListener('click',(event)=>{
    if(event.target.closest('.ura-bag')) closeMenu(false,true);
  },true);
  const currentPath=window.location.pathname.replace(/\/$/,'') || '/';
  menu?.querySelectorAll('a[href]').forEach(link=>{
    const destination=new URL(link.href,window.location.origin);
    if((destination.pathname.replace(/\/$/,'') || '/')===currentPath && destination.search===window.location.search) link.setAttribute('aria-current','page');
  });

  const revealItems = [...document.querySelectorAll('[data-ura-reveal]')];
  if (revealItems.length) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-revealed'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
      revealItems.forEach((item) => revealObserver.observe(item));
    }
  }

  const materialFolio = document.querySelector('[data-material-folio]');
  if (materialFolio) {
    const stage = materialFolio.querySelector('[data-material-stage]');
    const pin = materialFolio.querySelector('[data-material-pin]');
    const sheets = [...materialFolio.querySelectorAll('[data-material-sheet]')];
    const jumps = [...materialFolio.querySelectorAll('[data-material-jump]')];
    const markers = sheets.map((sheet) => sheet.querySelector('.ura-material-sheet__marker'));
    let stackFrame;
    let scrollFrame;
    let geometryFrame;
    let focusTimer;
    let resizeTimer;
    let refreshGeneration = 0;
    let stackEnabled = false;
    let currentSheetIndex = -1;
    let lastViewportScale = window.visualViewport?.scale || 1;
    let lastWindowWidth = window.innerWidth;
    let lastWindowHeight = window.innerHeight;
    let lastOrientation = window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait';
    let observedPreviewBar;
    let previewResizeObserver;
    let previewDiscoveryObserver;
    let stackMetrics = { start: 0, travel: 1 };

    const clamp = (value, minimum = 0, maximum = 1) => Math.min(maximum, Math.max(minimum, value));
    const smoothstep = (value) => value * value * (3 - 2 * value);
    const getScrollTop = () => {
      const root = document.scrollingElement || document.documentElement;
      return Math.max(0, root?.scrollTop || window.pageYOffset || window.scrollY || 0);
    };

    const setSheetAccess = (activeIndex) => {
      sheets.forEach((sheet, index) => {
        const surface = sheet.querySelector('.ura-material-sheet__surface');
        if (!surface) return;
        if (!stackEnabled) {
          surface.removeAttribute('aria-hidden');
          surface.inert = false;
          return;
        }
        const isActive = index === activeIndex;
        surface.setAttribute('aria-hidden', String(!isActive));
        surface.inert = !isActive;
      });
    };

    const setCurrentSheet = (index, force = false) => {
      if (index < 0 || index >= sheets.length) return;
      if (!force && currentSheetIndex === index) return;
      currentSheetIndex = index;
      sheets.forEach((item, itemIndex) => {
        item.classList.toggle('is-current', itemIndex === index);
        item.classList.toggle('is-complete', itemIndex < index);
      });
      jumps.forEach((jump, jumpIndex) => {
        if (jumpIndex === index) jump.setAttribute('aria-current', 'step');
        else jump.removeAttribute('aria-current');
      });
      setSheetAccess(index);
    };

    const revealSheet = (sheet) => sheet?.classList.add('is-threaded');

    const renderStack = (progress) => {
      if (!stackEnabled || !sheets.length) return;
      const lastIndex = sheets.length - 1;
      const position = clamp(progress) * lastIndex;
      const activeIndex = Math.min(lastIndex, Math.floor(position + .5));

      sheets.forEach((sheet, index) => {
        const reveal = index === 0 ? 1 : clamp(position - (index - 1));
        const accent = smoothstep(reveal);
        sheet.style.setProperty('--sheet-y', `${(1 - reveal) * 100}%`);
        sheet.style.setProperty('--sheet-thread', String(1 - accent));
        sheet.style.setProperty('--sheet-image-scale', String(1.018 - accent * .018));
        sheet.style.setProperty('--sheet-record-y', `${(1 - accent) * 12}px`);
        sheet.style.setProperty('--sheet-record-opacity', String(.82 + accent * .18));
        sheet.classList.toggle('is-threaded', reveal > .02);
      });

      materialFolio.style.setProperty('--folio-progress', String(lastIndex ? clamp(progress) : 1));
      setCurrentSheet(activeIndex);
    };

    const measureStack = () => {
      if (!stage || !pin || !stackEnabled) return;
      const stageRect = stage.getBoundingClientRect();
      const stickyTop = parseFloat(getComputedStyle(pin).top) || 0;
      stackMetrics = {
        start: getScrollTop() + stageRect.top - stickyTop,
        travel: Math.max(1, stage.offsetHeight - pin.getBoundingClientRect().height - stickyTop)
      };
    };

    const updateStack = () => {
      scrollFrame = 0;
      if (!stackEnabled) return;
      const progress = (getScrollTop() - stackMetrics.start) / stackMetrics.travel;
      renderStack(progress);
    };

    const queueStackUpdate = () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateStack);
    };

    const stackContentFits = () => {
      const results = sheets.map((sheet) => {
        const surface = sheet.querySelector('.ura-material-sheet__surface');
        const grid = sheet.querySelector('.ura-material-sheet__grid');
        const record = sheet.querySelector('.ura-material-sheet__record');
        const evidence = sheet.querySelector('.ura-material-sheet__evidence');
        const cta = sheet.querySelector('.ura-material-sheet__cta');
        if (!surface || !grid || !record || !evidence || !cta) return false;
        const surfaceRect = surface.getBoundingClientRect();
        const gridRect = grid.getBoundingClientRect();
        const recordRect = record.getBoundingClientRect();
        const evidenceRect = evidence.getBoundingClientRect();
        const ctaRect = cta.getBoundingClientRect();
        const reserve = window.innerWidth < 720 ? 14 : 8;
        return surface.scrollHeight <= surface.clientHeight + 2
          && grid.scrollHeight <= grid.clientHeight + 2
          && record.scrollHeight <= record.clientHeight + 2
          && gridRect.top >= surfaceRect.top - 2
          && Math.max(recordRect.bottom, evidenceRect.bottom, ctaRect.bottom) <= surfaceRect.bottom - reserve + 2;
      });
      return results.every(Boolean);
    };

    const resetNaturalFlow = () => {
      if (geometryFrame) cancelAnimationFrame(geometryFrame);
      geometryFrame = 0;
      stackEnabled = false;
      materialFolio.dataset.stack = 'off';
      materialFolio.removeAttribute('data-density');
      materialFolio.removeAttribute('data-measuring');
      materialFolio.style.removeProperty('--preview-inset');
      materialFolio.style.setProperty('--folio-progress', '0');
      sheets.forEach((sheet) => {
        sheet.style.removeProperty('--sheet-y');
        sheet.style.removeProperty('--sheet-thread');
        sheet.style.removeProperty('--sheet-image-scale');
        sheet.style.removeProperty('--sheet-record-y');
        sheet.style.removeProperty('--sheet-record-opacity');
        revealSheet(sheet);
      });
      setCurrentSheet(0, true);
    };

    if ('IntersectionObserver' in window) {
      const markerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || stackEnabled) return;
          const sheet = entry.target.closest('[data-material-sheet]');
          revealSheet(sheet);
          setCurrentSheet(sheets.indexOf(sheet));
        });
      }, { rootMargin: '-32% 0px -58% 0px', threshold: 0 });
      markers.filter(Boolean).forEach((marker) => markerObserver.observe(marker));
    }

    const getPreviewInset = () => {
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      if (!previewBar || getComputedStyle(previewBar).position !== 'fixed') return 0;
      const rect = previewBar.getBoundingClientRect();
      const overlapStart = Math.max(0, rect.top);
      const overlapEnd = Math.min(window.innerHeight, rect.bottom);
      return Math.max(0, overlapEnd - overlapStart);
    };

    const queueStackGeometry = () => {
      if (!stackEnabled || geometryFrame) return;
      geometryFrame = requestAnimationFrame(() => {
        geometryFrame = 0;
        materialFolio.style.setProperty('--preview-inset', `${getPreviewInset()}px`);
        requestAnimationFrame(() => {
          if (!stackEnabled) return;
          measureStack();
          updateStack();
        });
      });
    };

    const bindPreviewBar = () => {
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      if (!previewBar || previewBar === observedPreviewBar) return Boolean(previewBar);
      previewResizeObserver?.disconnect();
      observedPreviewBar = previewBar;
      if ('ResizeObserver' in window) {
        previewResizeObserver = new ResizeObserver(queueStackGeometry);
        previewResizeObserver.observe(previewBar);
      }
      queueStackRefresh();
      return true;
    };

    const refreshStack = () => {
      const generation = ++refreshGeneration;
      cancelAnimationFrame(stackFrame);
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = 0;
      stackFrame = requestAnimationFrame(() => {
        if (generation !== refreshGeneration) return;
        resetNaturalFlow();
        requestAnimationFrame(() => {
          if (generation !== refreshGeneration) return;
          bindPreviewBar();
          const previewInset = getPreviewInset();
          const viewportScale = window.visualViewport?.scale || 1;
          const eligible = !reducedMotion.matches
            && Boolean(stage && pin && sheets.length > 1)
            && window.innerWidth >= 300
            && viewportScale <= 1.05;

          if (!eligible) return;

          materialFolio.style.setProperty('--preview-inset', `${previewInset}px`);
          materialFolio.dataset.density = 'standard';
          materialFolio.dataset.stack = 'on';
          stackEnabled = true;
          currentSheetIndex = -1;
          sheets.forEach((sheet) => sheet.querySelector('img')?.setAttribute('loading', 'eager'));
          renderStack(0);
          materialFolio.dataset.measuring = 'true';

          const densities = ['standard', 'compact', 'tight'];
          const testDensity = (densityIndex) => {
            materialFolio.dataset.density = densities[densityIndex];
            requestAnimationFrame(() => {
              if (generation !== refreshGeneration) return;
              const fits = stackContentFits();
              if (!fits && densityIndex < densities.length - 1) {
                testDensity(densityIndex + 1);
                return;
              }
              if (!fits) {
                resetNaturalFlow();
                return;
              }
              materialFolio.removeAttribute('data-measuring');
              measureStack();
              updateStack();
            });
          };
          testDensity(0);
        });
      });
    };

    jumps.forEach((jump) => jump.addEventListener('click', (event) => {
      const index = Number(jump.dataset.materialJump);
      const sheet = sheets[index];
      const heading = sheet?.querySelector('h2');
      if (!sheet || !heading) return;
      event.preventDefault();
      if (!stackEnabled) {
        sheet.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      } else {
        const target = stackMetrics.start + stackMetrics.travel * (index / Math.max(1, sheets.length - 1));
        window.scrollTo({ top: target, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      window.clearTimeout(focusTimer);
      focusTimer = window.setTimeout(() => heading.focus({ preventScroll: true }), reducedMotion.matches ? 0 : 620);
    }));

    sheets.forEach((sheet) => sheet.addEventListener('focusin', () => {
      if (materialFolio.dataset.stack === 'on' && !sheet.classList.contains('is-current')) {
        const index = sheets.indexOf(sheet);
        const target = stackMetrics.start + stackMetrics.travel * (index / Math.max(1, sheets.length - 1));
        window.scrollTo({ top: target, behavior: 'auto' });
      }
    }));

    const queueStackRefresh = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refreshStack, 140);
    };
    const handleVisualViewportResize = () => {
      const nextScale = window.visualViewport?.scale || 1;
      if (Math.abs(nextScale - lastViewportScale) < .01) {
        queueStackGeometry();
        return;
      }
      lastViewportScale = nextScale;
      queueStackRefresh();
    };
    const handleWindowResize = () => {
      const nextWidth = window.innerWidth;
      const nextHeight = window.innerHeight;
      const nextOrientation = nextWidth >= nextHeight ? 'landscape' : 'portrait';
      const widthChanged = Math.abs(nextWidth - lastWindowWidth) > 1;
      const heightChanged = Math.abs(nextHeight - lastWindowHeight) > 24;
      const orientationChanged = nextOrientation !== lastOrientation;
      const mobileToolbarOnly = matchMedia('(pointer: coarse)').matches && !widthChanged && !orientationChanged;
      lastWindowWidth = nextWidth;
      lastWindowHeight = nextHeight;
      lastOrientation = nextOrientation;
      if (widthChanged || orientationChanged || (heightChanged && !mobileToolbarOnly)) queueStackRefresh();
      else queueStackGeometry();
    };
    window.addEventListener('scroll', queueStackUpdate, { passive: true });
    window.visualViewport?.addEventListener('scroll', queueStackUpdate, { passive: true });
    window.addEventListener('resize', handleWindowResize, { passive: true });
    window.visualViewport?.addEventListener('resize', handleVisualViewportResize, { passive: true });
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', queueStackRefresh);
    else reducedMotion.addListener?.(queueStackRefresh);
    window.addEventListener('pageshow', (event) => event.persisted ? refreshStack() : queueStackUpdate());
    if (!bindPreviewBar() && 'MutationObserver' in window) {
      previewDiscoveryObserver = new MutationObserver(() => {
        if (!bindPreviewBar()) return;
        previewDiscoveryObserver.disconnect();
      });
      previewDiscoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(() => previewDiscoveryObserver?.disconnect(), 12000);
    }
    document.fonts?.ready.then(() => stackEnabled ? queueStackGeometry() : refreshStack());
    setCurrentSheet(0, true);
    refreshStack();
  }

  const arrivals = document.querySelector('[data-ura-arrivals]');
  if (arrivals) {
    const rail = arrivals.querySelector('[data-ura-arrivals-rail]');
    const cards = [...arrivals.querySelectorAll('[data-ura-arrival-card]')];
    const previous = arrivals.querySelector('[data-ura-arrivals-prev]');
    const next = arrivals.querySelector('[data-ura-arrivals-next]');
    const progress = arrivals.querySelector('[data-ura-arrivals-progress]');
    const status = arrivals.querySelector('[data-ura-arrivals-status]');
    const number = (value) => String(value).padStart(2, '0');
    let arrivalsFrame;
    let targetArrivalIndex = null;

    const getArrivalTargetLeft = (index) => {
      if (!rail || !cards[index]) return 0;
      const railRect = rail.getBoundingClientRect();
      const paddingLeft = Number.parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      const cardLeft = cards[index].getBoundingClientRect().left - railRect.left + rail.scrollLeft - paddingLeft;
      return Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, cardLeft));
    };

    const getNearestArrivalIndex = () => {
      if (!rail || !cards.length) return 0;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const currentScroll = Math.max(0, rail.scrollLeft);
      if (maxScroll > 2 && currentScroll >= maxScroll - 2) return cards.length - 1;
      const railStyles = getComputedStyle(rail);
      const railLeft = rail.getBoundingClientRect().left + (Number.parseFloat(railStyles.paddingLeft) || 0);
      return cards.reduce((nearest, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Infinity }).index;
    };

    const updateArrivals = () => {
      if (!rail || !cards.length) return;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const currentScroll = Math.max(0, rail.scrollLeft);
      if (targetArrivalIndex !== null && Math.abs(currentScroll - getArrivalTargetLeft(targetArrivalIndex)) <= 2) {
        targetArrivalIndex = null;
      }
      const activeIndex = targetArrivalIndex ?? getNearestArrivalIndex();
      const scrollProgress = maxScroll ? Math.min(1, currentScroll / maxScroll) : 1;
      const registerProgress = cards.length > 1 ? (1 + scrollProgress * (cards.length - 1)) / cards.length : 1;
      arrivals.style.setProperty('--arrival-position', String(scrollProgress));
      if (progress) progress.style.strokeDashoffset = String(1 - registerProgress);
      cards.forEach((card, index) => {
        const active = index === activeIndex;
        card.classList.toggle('is-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
      if (status) status.textContent = `${number(activeIndex + 1)} / ${number(cards.length)}`;
      if (previous) previous.disabled = maxScroll <= 2 || activeIndex === 0;
      if (next) next.disabled = maxScroll <= 2 || activeIndex === cards.length - 1;
    };

    const queueArrivalsUpdate = () => {
      cancelAnimationFrame(arrivalsFrame);
      arrivalsFrame = requestAnimationFrame(updateArrivals);
    };

    const scrollArrivalTo = (index) => {
      if (!rail || !cards[index]) return;
      rail.scrollTo({
        left: getArrivalTargetLeft(index),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    const moveArrivals = (direction) => {
      if (!rail) return;
      const originIndex = targetArrivalIndex ?? getNearestArrivalIndex();
      const targetIndex = Math.max(0, Math.min(cards.length - 1, originIndex + direction));
      if (targetIndex === originIndex) return;
      targetArrivalIndex = targetIndex;
      updateArrivals();
      scrollArrivalTo(targetIndex);
    };

    previous?.addEventListener('click', () => moveArrivals(-1));
    next?.addEventListener('click', () => moveArrivals(1));
    rail?.addEventListener('scroll', queueArrivalsUpdate, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach((eventName) => rail?.addEventListener(eventName, () => {
      targetArrivalIndex = null;
      queueArrivalsUpdate();
    }, { passive: true }));
    cards.forEach((card, index) => card.addEventListener('focus', () => {
      targetArrivalIndex = index;
      updateArrivals();
      scrollArrivalTo(index);
    }));
    if ('ResizeObserver' in window && rail) new ResizeObserver(queueArrivalsUpdate).observe(rail);
    else window.addEventListener('resize', queueArrivalsUpdate, { passive: true });
    updateArrivals();
  }

  const garmentBlueprints = {
    tee: {
      label: 'TEE',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit garment width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Garment length',
      widthRange: [43, 76, 57],
      lengthRange: [56, 92, 71],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    jersey: {
      label: 'JERSEY',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit jersey width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Jersey length',
      widthRange: [43, 78, 58],
      lengthRange: [56, 96, 72],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    polo: {
      label: 'POLO',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit polo width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Polo length',
      widthRange: [43, 76, 56],
      lengthRange: [58, 96, 73],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    hoodie: {
      label: 'HOODIE',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit hoodie width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Hoodie length',
      widthRange: [45, 82, 60],
      lengthRange: [58, 96, 74],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    ziphoodie: {
      label: 'ZIP HOODIE',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit zip hoodie width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Zip hoodie length',
      widthRange: [45, 82, 60],
      lengthRange: [58, 96, 74],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    jacket: {
      label: 'JACKET',
      widthLabel: 'Pit-to-pit width',
      widthShort: 'Width',
      widthHelp: 'Armhole seam to opposite seam',
      widthAria: 'Pit-to-pit jacket width',
      lengthLabel: 'Garment length',
      lengthShort: 'Length',
      lengthHelp: 'Highest shoulder point to hem',
      lengthAria: 'Jacket length',
      widthRange: [45, 84, 61],
      lengthRange: [58, 100, 76],
      widthKeys: ['chest', 'pitToPit', 'pit_to_pit', 'width'],
      lengthKeys: ['length', 'garmentLength', 'garment_length']
    },
    shorts: {
      label: 'SHORTS',
      widthLabel: 'Waist width',
      widthShort: 'Waist',
      widthHelp: 'Waistband edge to edge',
      widthAria: 'Flat waist width',
      lengthLabel: 'Outseam length',
      lengthShort: 'Outseam',
      lengthHelp: 'Waistband to hem',
      lengthAria: 'Shorts outseam length',
      widthRange: [28, 60, 42],
      lengthRange: [30, 70, 50],
      widthKeys: ['waist', 'waistWidth', 'waist_width', 'width'],
      lengthKeys: ['outseam', 'outseamLength', 'outseam_length', 'length']
    },
    jeans: {
      label: 'JEANS',
      widthLabel: 'Waist width',
      widthShort: 'Waist',
      widthHelp: 'Waistband edge to edge',
      widthAria: 'Flat jeans waist width',
      lengthLabel: 'Outseam length',
      lengthShort: 'Outseam',
      lengthHelp: 'Waistband to hem',
      lengthAria: 'Jeans outseam length',
      widthRange: [28, 60, 42],
      lengthRange: [82, 120, 102],
      widthKeys: ['waist', 'waistWidth', 'waist_width', 'width'],
      lengthKeys: ['outseam', 'outseamLength', 'outseam_length', 'length']
    },
    pants: {
      label: 'PANTS',
      widthLabel: 'Waist width',
      widthShort: 'Waist',
      widthHelp: 'Waistband edge to edge',
      widthAria: 'Flat waist width',
      lengthLabel: 'Outseam length',
      lengthShort: 'Outseam',
      lengthHelp: 'Waistband to hem',
      lengthAria: 'Pants outseam length',
      widthRange: [28, 60, 42],
      lengthRange: [82, 120, 102],
      widthKeys: ['waist', 'waistWidth', 'waist_width', 'width'],
      lengthKeys: ['outseam', 'outseamLength', 'outseam_length', 'length']
    }
  };

  const garmentTypeFor = (product = {}) => {
    const source = `${product.garment || ''} ${product.fit || ''} ${product.productType || ''} ${product.title || ''} ${product.handle || ''}`.toLowerCase();
    if (/polo/.test(source)) return 'polo';
    if (/jersey|football shirt|soccer shirt/.test(source)) return 'jersey';
    if (/zip[-_ ]?hoodie|full[-_ ]?zip/.test(source)) return 'ziphoodie';
    if (/hoodie|hooded|pullover hoodie/.test(source)) return 'hoodie';
    if (/jacket|overshirt|coat|parka|blazer|track_jacket/.test(source)) return 'jacket';
    if (/shorts|short pant/.test(source)) return 'shorts';
    if (/jeans|denim pant/.test(source)) return 'jeans';
    if (/pants|trouser|jogger|sweatpant/.test(source)) return 'pants';
    return 'tee';
  };

  const sizeAxisValue = (size, keys) => {
    for (const key of keys) {
      const rawValue = size?.[key];
      if (rawValue === null || rawValue === undefined || rawValue === '') continue;
      const value = Number(rawValue);
      if (Number.isFinite(value)) return value;
    }
    return NaN;
  };

  const configureGarmentBlueprint = (root, product, selectors, resetValues = false) => {
    const type = garmentTypeFor(product);
    const config = garmentBlueprints[type];
    const blueprint = root.querySelector('[data-garment-blueprint]');
    if (blueprint) {
      blueprint.dataset.garmentType = type;
      blueprint.setAttribute('aria-label', `${config.label} flat garment measurement blueprint`);
      const blueprintLabel = blueprint.querySelector('[data-garment-blueprint-label]');
      if (blueprintLabel) blueprintLabel.textContent = `FLAT / ${config.label}`;
    }

    const widthInput = root.querySelector(selectors.widthInput);
    const lengthInput = root.querySelector(selectors.lengthInput);
    const labels = [
      [selectors.widthLabel, config.widthLabel],
      [selectors.widthHelp, config.widthHelp],
      [selectors.lengthLabel, config.lengthLabel],
      [selectors.lengthHelp, config.lengthHelp],
      [selectors.widthDiffLabel, config.widthShort.toUpperCase()],
      [selectors.lengthDiffLabel, config.lengthShort.toUpperCase()]
    ];
    labels.forEach(([selector, value]) => {
      if (!selector) return;
      const node = root.querySelector(selector);
      if (node) node.textContent = value;
    });

    const setRange = (input, range, ariaLabel) => {
      if (!input) return;
      input.min = String(range[0]);
      input.max = String(range[1]);
      input.setAttribute('aria-label', ariaLabel);
      if (resetValues || Number(input.value) < range[0] || Number(input.value) > range[1]) input.value = String(range[2]);
    };
    setRange(widthInput, config.widthRange, config.widthAria);
    setRange(lengthInput, config.lengthRange, config.lengthAria);
    root.dataset.garmentType = type;
    return { type, config };
  };

  const setBlueprintProgress = (root, axis, progress) => {
    root.querySelector('[data-garment-blueprint]')?.style.setProperty(`--blueprint-${axis}-progress`, String(progress));
  };

  const fitRoom = document.querySelector('[data-fit-room]');
  if (fitRoom) {
    const dataNode = fitRoom.querySelector('[data-fit-room-products]');
    let products = [];
    try { products = dataNode ? JSON.parse(dataNode.textContent) : []; } catch (_error) { products = []; }

    const productName = fitRoom.querySelector('[data-fit-room-product]');
    const productState = fitRoom.querySelector('[data-fit-room-product-state]');
    const productCounter = fitRoom.querySelector('[data-fit-room-counter]');
    const previousProduct = fitRoom.querySelector('[data-fit-room-prev]');
    const nextProduct = fitRoom.querySelector('[data-fit-room-next]');
    const widthInput = fitRoom.querySelector('[data-fit-room-width]');
    const lengthInput = fitRoom.querySelector('[data-fit-room-length]');
    const widthOutput = fitRoom.querySelector('[data-fit-room-width-output]');
    const lengthOutput = fitRoom.querySelector('[data-fit-room-length-output]');
    const resultState = fitRoom.querySelector('[data-fit-room-result-state]');
    const resultMatch = fitRoom.querySelector('[data-fit-room-match]');
    const resultTitle = fitRoom.querySelector('[data-fit-room-result-title]');
    const resultSize = fitRoom.querySelector('[data-fit-room-size]');
    const resultCopy = fitRoom.querySelector('[data-fit-room-result-copy]');
    const fullRoomLink = fitRoom.querySelector('[data-fit-room-link]');
    const unitButtons = [...fitRoom.querySelectorAll('[data-fit-room-unit]')];
    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    const requestedIndex = products.findIndex((product) => product.handle === requestedProduct);
    const verifiedIndex = products.findIndex((product) => product.verified && product.hasGuide && product.sizes?.length);
    let productIndex = requestedIndex >= 0 ? requestedIndex : verifiedIndex >= 0 ? verifiedIndex : 0;
    let displayUnit = 'in';
    let switchTimer;
    let lockTimer;
    let garmentContext = { type: 'tee', config: garmentBlueprints.tee };

    const selectedProduct = () => products[productIndex] || null;
    const measurement = (value, signed = false) => {
      const number = Number(value);
      const shown = displayUnit === 'cm' ? number : number / 2.54;
      const prefix = signed && shown > 0 ? '+' : '';
      return `${prefix}${shown.toFixed(1)} ${displayUnit}`;
    };

    const syncTape = (input, output, scaleProperty, scaleMin, scaleSpan, axis) => {
      if (!input || !output) return;
      const min = Number(input.min);
      const max = Number(input.max);
      const value = Number(input.value);
      const progress = Math.max(0, Math.min(1, (value - min) / (max - min)));
      output.textContent = measurement(value);
      input.setAttribute('aria-valuetext', measurement(value));
      input.closest('[data-fit-room-slider]')?.querySelector('[data-fit-room-tape-fill]')?.style.setProperty('width', `${(progress * 100).toFixed(2)}%`);
      fitRoom.querySelector('.ura-fit-room__console')?.style.setProperty(scaleProperty, (scaleMin + progress * scaleSpan).toFixed(3));
      setBlueprintProgress(fitRoom, axis, progress);
      const labels = input.closest('[data-fit-room-slider]')?.querySelectorAll(':scope > small > i');
      if (labels?.length === 2) {
        labels[0].textContent = displayUnit === 'cm' ? `${min}` : `${Math.round(min / 2.54)}`;
        labels[1].textContent = displayUnit === 'cm' ? `${max}` : `${Math.round(max / 2.54)}`;
      }
    };

    const noResult = (state, title, copy) => {
      resultState.textContent = state;
      resultMatch.textContent = '';
      resultTitle.textContent = title;
      resultSize.textContent = '—';
      resultCopy.textContent = copy;
      fitRoom.classList.remove('is-verified');
    };

    const renderResult = () => {
      const product = selectedProduct();
      if (!product) {
        noResult('VERIFIED CHART REQUIRED', 'No forced match.', 'Verified chart required.');
        return;
      }
      if (!product.hasGuide || !product.verified || !product.sizes?.length) {
        noResult(
          product.hasGuide ? 'CHART VERIFYING' : 'CHART REQUIRED',
          'No forced match.',
          product.hasGuide ? 'Awaiting factory verification.' : 'Verified chart required.'
        );
        return;
      }

      const factor = product.unit === 'in' ? 2.54 : 1;
      const width = Number(widthInput?.value);
      const length = Number(lengthInput?.value);
      const config = garmentContext.config;
      const ranked = product.sizes
        .filter((size) => Number.isFinite(sizeAxisValue(size, config.widthKeys)) && Number.isFinite(sizeAxisValue(size, config.lengthKeys)))
        .map((size) => {
          const widthDifference = sizeAxisValue(size, config.widthKeys) * factor - width;
          const lengthDifference = sizeAxisValue(size, config.lengthKeys) * factor - length;
          return { ...size, widthDifference, lengthDifference, score: Math.hypot(widthDifference, lengthDifference) };
        })
        .sort((a, b) => a.score - b.score);
      const best = ranked[0];
      if (!best) {
        noResult('CHART INCOMPLETE', 'No forced match.', `Verified ${config.widthShort.toLowerCase()} and ${config.lengthShort.toLowerCase()} required.`);
        return;
      }

      const match = Math.max(0, Math.round(100 - best.score * 4));
      if (match < 55 || Math.abs(best.widthDifference) > 12 || Math.abs(best.lengthDifference) > 12) {
        noResult('OUTSIDE VERIFIED RANGE', 'No confident match.', 'Outside this piece’s verified range.');
        return;
      }

      resultState.textContent = 'VERIFIED CHART';
      resultMatch.textContent = `${match}% MATCH`;
      resultTitle.textContent = 'Closest verified match';
      resultSize.textContent = best.size;
      resultCopy.textContent = `${config.widthShort} ${measurement(best.widthDifference, true)} · ${config.lengthShort} ${measurement(best.lengthDifference, true)} · Factory matched`;
      fitRoom.classList.add('is-verified');
    };

    const syncMeasurements = (animate = false) => {
      syncTape(widthInput, widthOutput, '--fit-width-scale', .58, .42, 'width');
      syncTape(lengthInput, lengthOutput, '--fit-length-scale', .52, .48, 'length');
      renderResult();
      if (!animate) return;
      fitRoom.classList.add('is-measuring');
      fitRoom.classList.remove('is-locked');
      window.clearTimeout(lockTimer);
      lockTimer = window.setTimeout(() => {
        fitRoom.classList.remove('is-measuring');
        fitRoom.classList.add('is-locked');
        window.setTimeout(() => fitRoom.classList.remove('is-locked'), 430);
      }, reducedMotion.matches ? 0 : 150);
    };

    const renderProduct = () => {
      const product = selectedProduct();
      if (!product) {
        garmentContext = configureGarmentBlueprint(fitRoom, {}, {
          widthInput: '[data-fit-room-width]',
          lengthInput: '[data-fit-room-length]',
          widthLabel: '[data-fit-room-width-label]',
          widthHelp: '[data-fit-room-width-help]',
          lengthLabel: '[data-fit-room-length-label]',
          lengthHelp: '[data-fit-room-length-help]'
        }, !fitRoom.dataset.garmentConfigured);
        fitRoom.dataset.garmentConfigured = 'true';
        productName.textContent = 'Fitting records are being indexed';
        productState.textContent = 'CONSTRUCTION DATA / PENDING';
        productCounter.textContent = '00 / 00';
        previousProduct.disabled = true;
        nextProduct.disabled = true;
        renderResult();
        return;
      }
      const nextType = garmentTypeFor(product);
      const resetBlueprint = !fitRoom.dataset.garmentConfigured || fitRoom.dataset.garmentType !== nextType;
      garmentContext = configureGarmentBlueprint(fitRoom, product, {
        widthInput: '[data-fit-room-width]',
        lengthInput: '[data-fit-room-length]',
        widthLabel: '[data-fit-room-width-label]',
        widthHelp: '[data-fit-room-width-help]',
        lengthLabel: '[data-fit-room-length-label]',
        lengthHelp: '[data-fit-room-length-help]'
      }, resetBlueprint);
      fitRoom.dataset.garmentConfigured = 'true';
      productName.textContent = product.title;
      productCounter.textContent = `${String(productIndex + 1).padStart(2, '0')} / ${String(products.length).padStart(2, '0')}`;
      productState.textContent = product.verified && product.hasGuide
        ? 'VERIFIED'
        : product.hasGuide ? 'VERIFYING' : 'PENDING';
      fullRoomLink.href = `/pages/perfect-fit?product=${encodeURIComponent(product.handle)}`;
      previousProduct.disabled = products.length < 2;
      nextProduct.disabled = products.length < 2;
      syncMeasurements();
    };

    const moveProduct = (direction) => {
      if (products.length < 2) return;
      fitRoom.classList.add('is-switching');
      window.clearTimeout(switchTimer);
      switchTimer = window.setTimeout(() => {
        productIndex = (productIndex + direction + products.length) % products.length;
        renderProduct();
        requestAnimationFrame(() => fitRoom.classList.remove('is-switching'));
      }, reducedMotion.matches ? 0 : 150);
    };

    previousProduct?.addEventListener('click', () => moveProduct(-1));
    nextProduct?.addEventListener('click', () => moveProduct(1));
    [widthInput, lengthInput].forEach((input) => input?.addEventListener('input', () => syncMeasurements(true)));
    unitButtons.forEach((button) => button.addEventListener('click', () => {
      displayUnit = button.dataset.fitRoomUnit;
      unitButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active);
      });
      syncMeasurements(true);
    }));
    renderProduct();
  }

  const fabricPage = document.querySelector('[data-ufi]');
  if (fabricPage && 'IntersectionObserver' in window) {
    const chapters = fabricPage.querySelectorAll('[data-ufi-chapter]');
    const map = {
      heat: ['TECHNOLOGY 01 / WARMTH', 'Heat Preservation', '345 GSM · HEAT RETENTION'],
      sorona: ['TECHNOLOGY 02 / MOVEMENT', 'Sorona® Quick-Dry', '220 GSM · MOISTURE MOVEMENT'],
      antimite: ['TECHNOLOGY 03 / PROTECTION', 'Anti-Mite Cotton', '305 GSM · 100% COTTON']
    };
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const key = entry.target.dataset.ufiChapter;
      fabricPage.querySelectorAll('[data-ufi-image]').forEach((image) => image.classList.toggle('is-active', image.dataset.ufiImage === key));
      const values = map[key];
      fabricPage.querySelector('[data-ufi-code]').textContent = values[0];
      fabricPage.querySelector('[data-ufi-title]').textContent = values[1];
      fabricPage.querySelector('[data-ufi-data]').textContent = values[2];
    }), { threshold: .55 });
    chapters.forEach((chapter) => observer.observe(chapter));
  }

  const fitPage = document.querySelector('[data-upf]');
  if (fitPage) {
    const productSelect = fitPage.querySelector('[data-upf-product]');
    const productState = fitPage.querySelector('[data-upf-product-state]');
    const productDataNode = fitPage.querySelector('[data-upf-products]');
    let products = [];
    try { products = productDataNode ? JSON.parse(productDataNode.textContent) : []; } catch (_error) { products = []; }
    const chestInput = fitPage.querySelector('[data-upf-chest]');
    const lengthInput = fitPage.querySelector('[data-upf-length]');
    let selectedProduct = null;
    let displayUnit = 'in';
    let garmentContext = { type: 'tee', config: garmentBlueprints.tee };

    const measurement = (value, signed = false) => {
      const number = Number(value);
      const shown = displayUnit === 'cm' ? number : number / 2.54;
      return `${signed && shown > 0 ? '+' : ''}${shown.toFixed(1)} ${displayUnit}`;
    };

    const syncTape = (input, output, property, scaleMin, scaleSpan, axis) => {
      if (!input || !output) return;
      const min = Number(input.min);
      const max = Number(input.max);
      const value = Number(input.value);
      const progress = Math.max(0, Math.min(1, (value - min) / (max - min)));
      output.textContent = measurement(value);
      input.setAttribute('aria-valuetext', measurement(value));
      input.closest('[data-upf-slider]')?.querySelector('[data-upf-tape-fill]')?.style.setProperty('width', `${(progress * 100).toFixed(2)}%`);
      fitPage.querySelector('.upf-room')?.style.setProperty(property, (scaleMin + progress * scaleSpan).toFixed(3));
      setBlueprintProgress(fitPage, axis, progress);
      const labels = input.closest('[data-upf-slider]')?.querySelectorAll(':scope > small > i');
      if (labels?.length === 2) {
        labels[0].textContent = displayUnit === 'cm' ? `${min}` : `${Math.round(min / 2.54)}`;
        labels[1].textContent = displayUnit === 'cm' ? `${max}` : `${Math.round(max / 2.54)}`;
      }
    };

    const syncMeasurements = () => {
      syncTape(chestInput, fitPage.querySelector('[data-upf-chest-output]'), '--upf-width-scale', .58, .42, 'width');
      syncTape(lengthInput, fitPage.querySelector('[data-upf-length-output]'), '--upf-length-scale', .52, .48, 'length');
      fitPage.querySelectorAll('[data-upf-unit]').forEach((button) => {
        const active = button.dataset.upfUnit === displayUnit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active);
      });
      renderResult();
    };

    const noResult = (stateText, titleText, copyText) => {
      fitPage.querySelector('[data-upf-result-state]').textContent = stateText;
      fitPage.querySelector('[data-upf-result-title]').textContent = titleText;
      fitPage.querySelector('[data-upf-result-copy]').textContent = copyText;
      fitPage.querySelector('[data-upf-match]').textContent = '';
      fitPage.querySelector('[data-upf-size]').textContent = '—';
      fitPage.querySelector('[data-upf-result-grid]').hidden = true;
      fitPage.classList.remove('is-verified');
    };

    const renderResult = () => {
      if (!selectedProduct) {
        noResult('VERIFIED CHART REQUIRED', 'Select an URA piece.', 'No size is forced without verified construction data.');
        return;
      }

      if (!selectedProduct.hasGuide || !selectedProduct.verified || !selectedProduct.sizes.length) {
        noResult(selectedProduct.hasGuide ? 'CHART VERIFYING' : 'CHART REQUIRED', 'No forced match.', selectedProduct.hasGuide ? 'Awaiting factory verification.' : 'Verified chart required.');
        return;
      }

      const factor = selectedProduct.unit === 'in' ? 2.54 : 1;
      const width = Number(chestInput.value);
      const length = Number(lengthInput.value);
      const config = garmentContext.config;
      const ranked = selectedProduct.sizes
        .filter((size) => Number.isFinite(sizeAxisValue(size, config.widthKeys)) && Number.isFinite(sizeAxisValue(size, config.lengthKeys)))
        .map((size) => {
          const widthDifference = sizeAxisValue(size, config.widthKeys) * factor - width;
          const lengthDifference = sizeAxisValue(size, config.lengthKeys) * factor - length;
          return { ...size, widthDifference, lengthDifference, score: Math.hypot(widthDifference, lengthDifference) };
        })
        .sort((a, b) => a.score - b.score);
      const best = ranked[0];
      if (!best) {
        noResult('CHART INCOMPLETE', 'No forced match.', `Verified ${config.widthShort.toLowerCase()} and ${config.lengthShort.toLowerCase()} required.`);
        return;
      }
      const match = Math.max(0, Math.round(100 - best.score * 4));
      if (match < 55 || Math.abs(best.widthDifference) > 12 || Math.abs(best.lengthDifference) > 12) {
        noResult('OUTSIDE VERIFIED RANGE', 'No confident match.', 'Outside this piece’s verified range.');
        return;
      }
      fitPage.querySelector('[data-upf-result-state]').textContent = 'VERIFIED CHART';
      fitPage.querySelector('[data-upf-result-title]').textContent = 'Closest verified match';
      fitPage.querySelector('[data-upf-result-copy]').textContent = 'A precise recommendation, not a guarantee.';
      fitPage.querySelector('[data-upf-match]').textContent = `${match}% MATCH`;
      fitPage.querySelector('[data-upf-size]').textContent = best.size;
      fitPage.querySelector('[data-upf-width-diff]').textContent = measurement(best.widthDifference, true);
      fitPage.querySelector('[data-upf-length-diff]').textContent = measurement(best.lengthDifference, true);
      fitPage.querySelector('[data-upf-result-grid]').hidden = false;
      fitPage.classList.add('is-verified');
    };

    [chestInput, lengthInput].forEach((input) => input?.addEventListener('input', syncMeasurements));
    fitPage.querySelectorAll('[data-upf-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        displayUnit = button.dataset.upfUnit;
        syncMeasurements();
      });
    });

    const renderProduct = () => {
      selectedProduct = products.find((product) => product.handle === productSelect.value) || null;
      const nextType = garmentTypeFor(selectedProduct || {});
      const resetBlueprint = !fitPage.dataset.garmentConfigured || fitPage.dataset.garmentType !== nextType;
      garmentContext = configureGarmentBlueprint(fitPage, selectedProduct || {}, {
        widthInput: '[data-upf-chest]',
        lengthInput: '[data-upf-length]',
        widthLabel: '[data-upf-width-label]',
        widthHelp: '[data-upf-width-help]',
        lengthLabel: '[data-upf-length-label]',
        lengthHelp: '[data-upf-length-help]',
        widthDiffLabel: '[data-upf-width-diff-label]',
        lengthDiffLabel: '[data-upf-length-diff-label]'
      }, resetBlueprint);
      fitPage.dataset.garmentConfigured = 'true';
      if (!selectedProduct) {
        productState.textContent = 'SELECT A PIECE';
        fitPage.querySelector('[data-upf-product-link]').href = '/collections/all';
      } else if (selectedProduct.verified && selectedProduct.hasGuide) {
        productState.textContent = 'VERIFIED CHART';
        fitPage.querySelector('[data-upf-product-link]').href = selectedProduct.url;
      } else if (selectedProduct.hasGuide) {
        productState.textContent = 'VERIFYING';
        fitPage.querySelector('[data-upf-product-link]').href = selectedProduct.url;
      } else {
        productState.textContent = 'CHART PENDING';
        fitPage.querySelector('[data-upf-product-link]').href = selectedProduct.url;
      }
      syncMeasurements();
    };
    productSelect?.addEventListener('change', renderProduct);

    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    const initialProduct = products.find((product) => product.handle === requestedProduct)
      || products.find((product) => product.verified && product.hasGuide && product.sizes?.length)
      || null;
    if (initialProduct && productSelect) productSelect.value = initialProduct.handle;
    renderProduct();
  }

  const productRoot = document.querySelector('[data-ura-product]');
  const variantsNode = productRoot?.querySelector('[data-ura-variants]');
  if (productRoot && variantsNode) {
    const variants = JSON.parse(variantsNode.textContent);
    const inputs = [...productRoot.querySelectorAll('[data-ura-option-input]')];
    const variantId = productRoot.querySelector('[data-ura-variant-id]');
    const addButton = productRoot.querySelector('.ura-pdp__add, .ura2-pdp__add');
    const addLabel = productRoot.querySelector('[data-ura-add-label]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: productRoot.dataset.currency || 'USD'
    });

    const pdpFit = productRoot.querySelector('[data-pdp-fit]');
    if (pdpFit) {
      const productDataNode = pdpFit.querySelector('[data-pdp-fit-product]');
      let fitProduct = null;
      try { fitProduct = productDataNode ? JSON.parse(productDataNode.textContent) : null; } catch (_error) { fitProduct = null; }

      const widthInput = pdpFit.querySelector('[data-pdp-fit-width]');
      const lengthInput = pdpFit.querySelector('[data-pdp-fit-length]');
      const resultState = pdpFit.querySelector('[data-pdp-fit-state]');
      const resultMatch = pdpFit.querySelector('[data-pdp-fit-match]');
      const resultTitle = pdpFit.querySelector('[data-pdp-fit-title]');
      const resultSize = pdpFit.querySelector('[data-pdp-fit-size]');
      const resultCopy = pdpFit.querySelector('[data-pdp-fit-copy]');
      const applyButton = pdpFit.querySelector('[data-pdp-fit-apply]');
      const unitButtons = [...pdpFit.querySelectorAll('[data-pdp-fit-unit]')];
      const sizeInputs = inputs.filter((input) => input.name.toLowerCase().includes('size'));
      let displayUnit = 'in';
      let recommendedSize = '';
      const garmentContext = configureGarmentBlueprint(pdpFit, fitProduct || {}, {
        widthInput: '[data-pdp-fit-width]',
        lengthInput: '[data-pdp-fit-length]',
        widthLabel: '[data-pdp-fit-width-label]',
        widthHelp: '[data-pdp-fit-width-help]',
        lengthLabel: '[data-pdp-fit-length-label]',
        lengthHelp: '[data-pdp-fit-length-help]'
      }, true);

      const normalizeSize = (value) => String(value || '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, '')
        .replace(/^XXL$/, '2XL')
        .replace(/^XXXL$/, '3XL');

      const sizeInputFor = (value) => sizeInputs.find((input) => normalizeSize(input.value) === normalizeSize(value));

      const measurement = (value, signed = false) => {
        const number = Number(value);
        const shown = displayUnit === 'cm' ? number : number / 2.54;
        return `${signed && shown > 0 ? '+' : ''}${shown.toFixed(1)} ${displayUnit}`;
      };

      const syncTape = (input, output, property, scaleMin, scaleSpan, axis) => {
        if (!input || !output) return;
        const min = Number(input.min);
        const max = Number(input.max);
        const value = Number(input.value);
        const progress = Math.max(0, Math.min(1, (value - min) / (max - min)));
        output.textContent = measurement(value);
        input.setAttribute('aria-valuetext', measurement(value));
        input.closest('[data-pdp-fit-slider]')?.querySelector('[data-pdp-fit-fill]')?.style.setProperty('width', `${(progress * 100).toFixed(2)}%`);
        pdpFit.style.setProperty(property, (scaleMin + progress * scaleSpan).toFixed(3));
        setBlueprintProgress(pdpFit, axis, progress);
      };

      const noResult = (stateText, titleText, copyText) => {
        recommendedSize = '';
        resultState.textContent = stateText;
        resultMatch.textContent = '';
        resultTitle.textContent = titleText;
        resultSize.textContent = '—';
        resultCopy.textContent = copyText;
        applyButton.disabled = true;
        applyButton.textContent = 'Use recommended size';
        applyButton.removeAttribute('data-recommended-size');
        pdpFit.classList.remove('is-verified', 'is-applied');
      };

      const renderFitResult = () => {
        if (!fitProduct || !fitProduct.hasGuide || !fitProduct.verified || !Array.isArray(fitProduct.sizes) || !fitProduct.sizes.length) {
          noResult(
            fitProduct?.hasGuide ? 'CHART VERIFYING' : 'CHART REQUIRED',
            'No forced match.',
            fitProduct?.hasGuide ? 'Awaiting factory verification.' : 'Verified chart required.'
          );
          return;
        }

        const factor = fitProduct.unit === 'in' ? 2.54 : 1;
        const width = Number(widthInput?.value);
        const length = Number(lengthInput?.value);
        const config = garmentContext.config;
        const ranked = fitProduct.sizes
          .filter((size) => Number.isFinite(sizeAxisValue(size, config.widthKeys)) && Number.isFinite(sizeAxisValue(size, config.lengthKeys)))
          .map((size) => {
            const widthDifference = sizeAxisValue(size, config.widthKeys) * factor - width;
            const lengthDifference = sizeAxisValue(size, config.lengthKeys) * factor - length;
            return { ...size, widthDifference, lengthDifference, score: Math.hypot(widthDifference, lengthDifference) };
          })
          .sort((a, b) => a.score - b.score);
        const best = ranked[0];

        if (!best) {
          noResult('CHART INCOMPLETE', 'No forced match.', `Verified ${config.widthShort.toLowerCase()} and ${config.lengthShort.toLowerCase()} required.`);
          return;
        }

        const match = Math.max(0, Math.round(100 - best.score * 4));
        if (match < 55 || Math.abs(best.widthDifference) > 12 || Math.abs(best.lengthDifference) > 12) {
          noResult('OUTSIDE VERIFIED RANGE', 'No confident match.', 'Outside this piece\u2019s verified range.');
          return;
        }

        recommendedSize = String(best.size || '');
        const matchingInput = sizeInputFor(recommendedSize);
        resultState.textContent = 'VERIFIED CHART';
        resultMatch.textContent = `${match}% MATCH`;
        resultTitle.textContent = 'Closest verified match';
        resultSize.textContent = recommendedSize;
        resultCopy.textContent = `${config.widthShort} ${measurement(best.widthDifference, true)} \u00b7 ${config.lengthShort} ${measurement(best.lengthDifference, true)} \u00b7 Factory matched`;
        applyButton.disabled = !matchingInput;
        applyButton.textContent = matchingInput ? `Use size ${recommendedSize}` : 'Size unavailable';
        if (matchingInput) applyButton.dataset.recommendedSize = recommendedSize;
        else applyButton.removeAttribute('data-recommended-size');
        pdpFit.classList.add('is-verified');
        pdpFit.classList.remove('is-applied');
      };

      const syncFitMeasurements = () => {
        syncTape(widthInput, pdpFit.querySelector('[data-pdp-fit-width-output]'), '--pdp-fit-width', .58, .42, 'width');
        syncTape(lengthInput, pdpFit.querySelector('[data-pdp-fit-length-output]'), '--pdp-fit-length', .52, .48, 'length');
        renderFitResult();
      };

      [widthInput, lengthInput].forEach((input) => input?.addEventListener('input', syncFitMeasurements));
      unitButtons.forEach((button) => button.addEventListener('click', () => {
        displayUnit = button.dataset.pdpFitUnit;
        unitButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active);
        });
        syncFitMeasurements();
      }));

      applyButton?.addEventListener('click', () => {
        const sizeInput = sizeInputFor(recommendedSize);
        if (!sizeInput) return;
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        pdpFit.classList.add('is-applied');
        applyButton.textContent = `Size ${recommendedSize} selected`;
      });

      sizeInputs.forEach((input) => input.addEventListener('change', () => {
        const selected = input.checked && normalizeSize(input.value) === normalizeSize(recommendedSize);
        pdpFit.classList.toggle('is-applied', Boolean(selected));
        if (selected) applyButton.textContent = `Size ${recommendedSize} selected`;
        else if (recommendedSize) applyButton.textContent = `Use size ${recommendedSize}`;
      }));

      syncFitMeasurements();
    }

    const syncVariant = () => {
      productRoot.querySelectorAll('[data-ura-option]').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const label = group.querySelector('[data-ura-option-value]');
        if (checked && label) label.textContent = checked.value;
      });
      const chosen = [...productRoot.querySelectorAll('[data-ura-option]')].map((group) => group.querySelector('input:checked')?.value);
      const match = variants.find((variant) => variant.options.every((value, index) => value === chosen[index]));
      if (!match) return;
      variantId.value = match.id;
      addButton.disabled = !match.available;
      addLabel.textContent = match.available ? 'Add to bag' : 'Sold out';
      const price = productRoot.querySelector('[data-ura-product-price]');
      if (price) price.textContent = money.format(match.price / 100);
      history.replaceState({}, '', `${location.pathname}?variant=${match.id}`);
    };
    inputs.forEach((input) => input.addEventListener('change', syncVariant));
  }
})();





